import { create } from 'zustand';

import { TNotifyColors } from "~/components/Notify";

interface INotification {
	visible: boolean;
	msg: string;
	color: TNotifyColors;
}

interface INotificationStore {
	notification: INotification;
	setNotification: (msg: string, color?: TNotifyColors) => void;
	clearNotification: () => void;
}

export const notificationStore = create<INotificationStore>(set => ({
	notification: {
		visible: false,
		msg: "",
		color: "success",
	},
	setNotification: (msg, color = "success") => set(() => ({
		notification: {
			visible: true,
			msg,
			color,
		},
	})),
	clearNotification: () => set(state => ({
		notification: {
			...state.notification,
			visible: false,
		},
	})),
}));
